var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Logradouro Tipo:"}},[_c('b-form-select',{attrs:{"options":_vm.tipos},model:{value:(_vm.valor),callback:function ($$v) {_vm.valor=$$v},expression:"valor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }